import React from 'react';
export function GuaranteeSection() {
  return <section className="bg-cream py-14 md:py-20" aria-labelledby="guarantee-title" data-id="element-58" data-mp="1i4znmpm6fims">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-59" data-mp="4xcketlm6eah">
        <div className="mx-auto max-w-[480px] rounded-[14px] border border-line bg-cream-soft px-6 py-9 text-center" data-id="element-60" data-mp="9u38o47kog6z">
          <span className="mx-auto flex h-14 w-14 flex-col items-center justify-center rounded-full bg-carbon text-ink-light" data-id="element-61" data-mp="eu8u32n916gm">
            <span className="text-[15px] font-extrabold leading-none" data-id="element-62" data-mp="jqg1z0z7gs17">7</span>
            <span className="mt-0.5 text-[7px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-63" data-mp="nskw00tkfqod">
              Días
            </span>
          </span>
          <h2 id="guarantee-title" className="mt-5 text-[22px] leading-[1.18] sm:text-[28px]" data-id="element-64" data-mp="xjnucuv41rjy">
            Genera más atracción en los próximos 7 días o te devolvemos tu dinero”
          </h2>
          <p className="mx-auto mt-4 max-w-[400px] text-[12px] font-medium leading-relaxed text-ink-muted md:text-[13px]" data-id="element-65" data-mp="17hv9r99r41ju">
            Pon en práctica el sistema durante 7 días. Si al aplicarlo no sientes más claridad, seguridad e intención en tu forma de comunicarte,puedes solicitar el reembolso dentro del plazo de garantía.
Sin complicaciones. Sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}